import React, { useState } from 'react';
import { IoMdMenu, IoMdClose } from 'react-icons/io';
import { FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NavLink = ({ children, href }) => (
  <a className="hover:shadow-lg pl-4 pr-4 text-center bg-principal text-white rounded-full border-principal hover:bg-white hover:text-principal transition-all duration-300" href={href}>
    {children}
  </a>
);

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-principal">
      <nav className="flex justify-between items-center w-[85%] mx-auto">
        <Link to="/" className='flex items-center md:mr-80 mr-0'>
          <img src={`${process.env.PUBLIC_URL}/name.svg`} alt='name' className='h-14 m-2' />
        </Link>
        <div className={`duration-1000 md:static absolute text-white font-mukta text-lg md:min-h-fit min-h-[30vh] left-0 ${isOpen ? 'top-[10%] z-10' : 'top-[-100%] z-10'}  md:w-auto w-full flex justify-center items-center text-center bg-principal`}>
          <ul className="flex md:flex-row flex-col md:items-center md:gap-[2vw] gap-6">

            <Link to="/menu">
              <NavLink href="#">Servicios</NavLink>
            </Link>
            <Link to="/aboutme">
              <NavLink href="#">Sobre Mí</NavLink>
            </Link>
            <li>
              <div className="flex items-center">
                <NavLink href="https://wa.me/+573104032213" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp size={23} className="inline-block mr-2" />
                  Contáctame
                </NavLink>
              </div>
            </li>
          </ul>
        </div>
        <div className="flex items-center gap-6">
          <div onClick={onToggleMenu} className="text-3xl cursor-pointer md:hidden text-white pr-4 bg-principal">
            {isOpen ? <IoMdClose /> : <IoMdMenu />}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default NavBar;